document.addEventListener("DOMContentLoaded", function () {
  const autumnItems = ["🍂", "🍁", "🎃"];

  function createAutumnItem() {
    const item = document.createElement("div");

    item.className = "minelys-autumn-float";

    item.textContent =
      autumnItems[Math.floor(Math.random() * autumnItems.length)];

    item.style.left = Math.random() * 95 + "vw";

    item.style.fontSize =
      14 + Math.random() * 12 + "px";

    item.style.animationDuration =
      7 + Math.random() * 5 + "s";

    document.body.appendChild(item);

    setTimeout(function () {
      item.remove();
    }, 13000);
  }

  setInterval(function () {
    if (Math.random() > 0.35) {
      createAutumnItem();
    }
  }, 2200);
});